module.exports = __webpack_public_path__ + "media/brands/img3-0def41cf.jpg";